import { Component, Input, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { ScreenType } from 'projects/common/model/ScreenType';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { HeaderWrapperComponent } from '../header-wrapper/header-wrapper.component';
import { OffersComponent } from '../offers/offers/offers.component';
import { TipMessage } from './tip-message.model';
import { VideoPlayerService } from 'projects/common/services/video-player.service';

@Component({
  selector: 'tip-message',
  template: `
    <div class="tip-message" [ngClass]="{header: header, offer: offer}">
      <div class="tip-message-text" (click)="open()">
        <span class="eva-3-body-2" [innerHTML]="tipMessage.text"></span>
      </div>
      <div class="eva-3-avatar -image" [attr.data-video-id]="tipMessage.video?.id" [ngClass]="{video: this.tipMessage.video}" (click)="open()">
        <img class="avatar-image" [src]="src + '/120x120?op=TRUNCATE'" loading="lazy" alt="avatar"/>
      </div>
    </div>
  `,
  styleUrls: ['./tip-message.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class TipMessageComponent implements OnInit {
  @Input() tipMessage: TipMessage;
  @Input() moduleId: string;
  @Input() uniqueId?: string;
  src?: string;
  screenType: ScreenType;
  header: boolean;
  offer: boolean;

  constructor(private landingModelService: LandingModelService, private mediaPictureService: MediaPictureService, private videoPlayerService: VideoPlayerService,
    @Optional() header: HeaderWrapperComponent, @Optional() offer: OffersComponent) {
    this.header = !!header;
    this.offer = !!offer;
  }

  ngOnInit(): void {
    this.src = this.getMediaUrl();
  }

  getMediaUrl() {
    const screenType = this.landingModelService.getLandingModel().device.type;
    this.screenType = screenType;
    const image = this.tipMessage.image || this.tipMessage.video!.image;
    const src = screenType === ScreenType.DESKTOP ? image.src : image.src_mobile || image.src;
    return this.mediaPictureService.getMediaUrl(src);
  }

  open() {
    if (this.tipMessage.video) {
      this.videoPlayerService.show({
        moduleId: this.getModuleId(),
        uniqueId: this.uniqueId,
        positionIndex: 0,
        moduleIndex: 0
      }, this.tipMessage.video);
    }
  }

  getModuleId() {
    return this.moduleId;
  }
}
